document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.article-metafield-slider');

  sliders.forEach((slider) => {
    const track = slider.querySelector('.article-metafield-slider__track');
    const slides = slider.querySelectorAll('.article-metafield-slider__slide');
    const prevBtn = slider.querySelector('.article-metafield-slider__prev');
    const nextBtn = slider.querySelector('.article-metafield-slider__next');
    const dots = slider.querySelectorAll('.article-metafield-slider__dot');

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;

    const getGap = () => {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || 0);
    };

    const getSlideWidth = () => {
      const firstSlide = slides[0];
      return firstSlide ? firstSlide.offsetWidth : 0;
    };

    const getTranslateXByIndex = (index) => {
      const slideWidth = getSlideWidth();
      const gap = getGap();
      return -1 * index * (slideWidth + gap);
    };

    const setSliderPosition = (translateX, withTransition = true) => {
      track.style.transition = withTransition ? 'transform 0.35s ease' : 'none';
      track.style.transform = `translateX(${translateX}px)`;
    };

    const updateDots = () => {
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    };

    const updateSlider = (withTransition = true) => {
      currentTranslate = getTranslateXByIndex(currentIndex);
      prevTranslate = currentTranslate;
      setSliderPosition(currentTranslate, withTransition);
      updateDots();
    };

    const goToPrev = () => {
      currentIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
      updateSlider();
    };

    const goToNext = () => {
      currentIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
      updateSlider();
    };

    prevBtn?.addEventListener('click', goToPrev);
    nextBtn?.addEventListener('click', goToNext);

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        currentIndex = index;
        updateSlider();
      });
    });

    const pointerDown = (clientX) => {
      isDragging = true;
      startX = clientX;
      slider.classList.add('is-dragging');
      track.style.transition = 'none';
    };

    const pointerMove = (clientX) => {
      if (!isDragging) return;
      const diff = clientX - startX;
      currentTranslate = prevTranslate + diff;
      setSliderPosition(currentTranslate, false);
    };

    const pointerUp = () => {
      if (!isDragging) return;

      isDragging = false;
      slider.classList.remove('is-dragging');

      const movedBy = currentTranslate - prevTranslate;
      const threshold = getSlideWidth() * 0.15;

      if (movedBy < -threshold) {
        currentIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
      } else if (movedBy > threshold) {
        currentIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
      }

      updateSlider(true);
    };

    slider.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      pointerDown(e.touches[0].clientX);
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      if (e.touches.length !== 1) return;
      pointerMove(e.touches[0].clientX);
    }, { passive: true });

    slider.addEventListener('touchend', pointerUp);

    slider.addEventListener('mousedown', (e) => {
      e.preventDefault();
      pointerDown(e.clientX);
    });

    window.addEventListener('mousemove', (e) => {
      pointerMove(e.clientX);
    });

    window.addEventListener('mouseup', pointerUp);

    slider.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    window.addEventListener('resize', () => {
      updateSlider(false);
    });

    updateSlider(false);
  });
});